import { useQuery } from '@tanstack/react-query';

import useDebounced from '~/hooks/useDebounced';

import { rateCodeQueryKeys } from './rateCodeQueryKeys';
import { getAllRateCodesByCodes } from './useGetRateCodesByCodes';

const SEARCH_DELAY_MS = 500;

export function useSearchRateCodes(search: string) {
  const code = useDebounced(search.trim(), SEARCH_DELAY_MS);
  return useQuery({
    queryKey: [...rateCodeQueryKeys.lists(), 'search', search.trim()],
    queryFn: () => getAllRateCodesByCodes([code]),
    enabled: !!code && code === search.trim(),
  });
}
